var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-category-type-edit-modal",
        title: "Edit Category Type",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Category Type Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("name") },
                model: {
                  value: _vm.formData.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("name") } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formValidation.name) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Production Method" } },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { value: true, "unchecked-value": false },
                  model: {
                    value: _vm.formData.is_grow,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "is_grow", $$v)
                    },
                    expression: "formData.is_grow",
                  },
                },
                [
                  _c("strong", [_vm._v("Grow")]),
                  _vm._v(" production method\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  attrs: { value: true, "unchecked-value": false },
                  model: {
                    value: _vm.formData.is_manufacture,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "is_manufacture", $$v)
                    },
                    expression: "formData.is_manufacture",
                  },
                },
                [
                  _c("strong", [_vm._v("Manufacture")]),
                  _vm._v(" production method\n        "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-between",
            },
            [
              _c("strong", [_vm._v("METRC matching categories")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "success" },
                  on: { click: _vm.addNewMetrcCategory },
                },
                [_c("b-icon-plus")],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.formData.metrc_categories, function (categoryName, index) {
            return _c(
              "b-form-group",
              { key: index, attrs: { label: "METRC Category" } },
              [
                _c(
                  "b-input-group",
                  [
                    _c("b-form-select", {
                      attrs: {
                        options: _vm.allMetrcCategories,
                        type: "text",
                        state: _vm.fieldValid(`metrc_categories.${index}`),
                      },
                      model: {
                        value: _vm.formData.metrc_categories[index],
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData.metrc_categories,
                            index,
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "formData.metrc_categories[index]",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger" },
                            on: { click: () => _vm.removeMetrCategory(index) },
                          },
                          [_c("b-icon-x")],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-invalid-feedback",
                  {
                    attrs: {
                      state: _vm.fieldValid(`metrc_categories.${index}`),
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.formValidation[`metrc_categories.${index}`]
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n        Submit\n        "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }